var render = function render(){var _vm=this,_c=_vm._self._c;return _c('timeline',{ref:"timeline",staticClass:"team__timeline vis-today",attrs:{"items":_vm.items,"groups":_vm.groups,"options":_vm.options},on:{"click":_vm.handleItemClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }